import { env } from "../../libs/utils/env";

export const CURRENCY_CODES = {
    PEN: "PEN",
};

export const CURRENCY_CODES_VALUES = {
    [CURRENCY_CODES.PEN]: env.int(process.env.REACT_APP_PEN_COD),
};

export const PACIFICO_ONLINE = "PACIFICO ONLINE";

export const PRODUCT_NAME = "Vida Ley Empleados";

export const SAFETYPAY_DATA = {
    API_KEY: env.string(process.env.REACT_APP_SAFETYPAY_API_KEY),
    EXPIRATION_TIME: env.int(process.env.REACT_APP_SAFETYPAY_EXPIRATION_TIME),
    SIGNATURE_KEY: env.string(process.env.REACT_APP_SAFETYPAY_SIGNATURE_KEY),
};

export const ISSUANCE_DATA = {
    BROKER_TYPE_DOCUMENT_NUMBER: env.string(
        process.env.REACT_APP_BROKER_TYPE_DOCUMENT_NUMBER
    ),
    BROKER_DOCUMENT_NUMBER: env.int(
        process.env.REACT_APP_BROKER_DOCUMENT_NUMBER
    ),
    CODE_PACKAGE_ADDITIONAL: env.string(
        process.env.REACT_APP_CODE_PACKAGE_ADDITIONAL,
        ""
    ),
    ID_BROKER: env.int(process.env.REACT_APP_ID_BROKER),
};

export const LOADING_TITLE = "Hola!";

export const LOADING_MESSAGE = "Estamos generando tu código de pago";

export const QUEUE_ERROR = "ERROR_400_ENCOLAR";
